import { useLocation } from "react-router";
import { Helmet } from "react-helmet";
import { amazonCampaignIds } from "../../common/constants";

export const MetaTags = () => {
  const location = useLocation();
  const matchedAmazonCampaignID = amazonCampaignIds.find((el) => location.pathname.match(el));

  return (
    <Helmet>
      <meta property="og:image" content={!matchedAmazonCampaignID ? "/campaign/preview.png" : `/previews/${matchedAmazonCampaignID}.png`} />
    </Helmet>
  );
};
